/**
 * Pure H OS · Sprint 2 · Shortcuts Modal.
 *
 * Shows keyboard shortcut registry. Composes Modal + Kbd + Card structure.
 */
import { usePlatform } from "../context/PlatformContext";
import { Modal, Kbd } from "./lib.overlay";
import { KEYBOARD_SHORTCUTS } from "../mocks/platformData";

export default function ShortcutsModal() {
  const { shortcutsOpen, closeShortcuts } = usePlatform();

  const grouped = KEYBOARD_SHORTCUTS.reduce<Record<string, typeof KEYBOARD_SHORTCUTS>>((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s);
    return acc;
  }, {});

  return (
    <Modal open={shortcutsOpen} onClose={closeShortcuts} maxWidth={560} testId="shortcuts-modal">
      <div
        className="px-5 py-4"
        style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}
      >
        <div
          className="text-[10px] font-semibold uppercase mb-1"
          style={{ color: "var(--ph-ink-muted)", letterSpacing: "var(--ph-tracking-eyebrow)" }}
        >
          Reference
        </div>
        <div
          style={{
            fontFamily: "var(--ph-display-font)",
            fontSize: "var(--ph-size-h2)",
            fontWeight: 600,
            color: "var(--ph-ink-strong)",
            letterSpacing: "var(--ph-tracking-title)",
          }}
        >
          Keyboard Shortcuts
        </div>
      </div>

      <div className="p-5 space-y-5 max-h-[70vh] overflow-y-auto" data-testid="shortcuts-list">
        {Object.entries(grouped).map(([cat, list]) => (
          <div key={cat}>
            <div
              className="text-[10px] font-semibold uppercase mb-2"
              style={{ color: "var(--ph-ink-muted)", letterSpacing: "var(--ph-tracking-eyebrow)" }}
            >
              {cat}
            </div>
            <div className="space-y-1">
              {list.map((s, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between py-1.5 px-2"
                  data-testid={`shortcut-row-${s.keys.join("-")}`}
                  style={{ borderRadius: "var(--ph-radius-sm)" }}
                >
                  <div className="text-sm" style={{ color: "var(--ph-ink-strong)" }}>{s.label}</div>
                  <div className="flex items-center gap-1">
                    {s.keys.map((k, ki) => <Kbd key={ki}>{k}</Kbd>)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div
        className="flex items-center justify-between px-5 py-3"
        style={{
          borderTop: "1px solid var(--ph-border-subtle)",
          background: "var(--ph-surface)",
          borderBottomLeftRadius: "var(--ph-radius-lg)",
          borderBottomRightRadius: "var(--ph-radius-lg)",
        }}
      >
        <span className="text-[11px]" style={{ color: "var(--ph-ink-muted)" }}>
          Press <Kbd>Esc</Kbd> to close
        </span>
        <span className="text-[11px]" style={{ color: "var(--ph-ink-muted)" }}>
          Pure H OS · Sprint 2
        </span>
      </div>
    </Modal>
  );
}
